const API = process.env.REACT_APP_BACKEND_URL || "";

async function req(path, opts = {}) {
  const r = await fetch(`${API}/api/investment${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...opts.headers },
    ...opts,
  });
  if (!r.ok) {
    let msg = r.statusText;
    try {
      const b = await r.json();
      msg = b.detail || b.message || msg;
    } catch {}
    throw new Error(msg);
  }
  return r.json();
}

export const getCollections = (category) =>
  req(`/collections${category ? `?category=${encodeURIComponent(category)}` : ""}`);

export const getCollection = (id) => req(`/collections/${id}`);

export const getQuote = (collectionId, quantity) =>
  req(`/orders/quote?collectionId=${encodeURIComponent(collectionId)}&quantity=${quantity}`);

export const createOrder = (body) =>
  req("/orders", { method: "POST", body: JSON.stringify(body) });

export const getOrders = (userId) =>
  req(`/orders${userId ? `?userId=${encodeURIComponent(userId)}` : ""}`);

export const getOrder = (id) => req(`/orders/${id}`);

export const getWalletBalances = (userId) =>
  req(`/wallet/balances?userId=${encodeURIComponent(userId)}`);

export const getWithdrawals = (userId) =>
  req(`/wallet/withdrawals?userId=${encodeURIComponent(userId)}`);

export const createWithdrawal = (userId, tokenId, amount, toAddress) =>
  req("/wallet/withdraw", {
    method: "POST",
    body: JSON.stringify({ userId, tokenId, amount, toAddress }),
  });

export const provisionWallet = (zcarsUserId) =>
  req("/wallet/provision", {
    method: "POST",
    body: JSON.stringify({ zcarsUserId }),
  });

export const getStripeConfig = () => req("/stripe-config");

export const payOrder = (orderId, paymentIntentId) =>
  req(`/orders/${orderId}/pay`, {
    method: "POST",
    body: JSON.stringify({ paymentIntentId }),
  });

export const formatCents = (cents) => `$${(cents / 100).toFixed(2)}`;
